exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bjsptnewslistw .el-pagination.is-background .el-pager li:not(.disabled):hover {\n  color: #5670f3;\n}\n.bjsptnewslistw .el-pagination.is-background .el-pager li:not(.disabled).active {\n  background-color: #5670f3;\n}\n.bjsptnewslistw .el-pagination.is-background .el-pager li:not(.disabled).active:hover {\n  color: #fff;\n}", ""]);

// exports
